// @flow
import * as React from 'react';
import { DashboardCard } from '../dashboard-card';
import { environment } from '../../../../../../../environments/environment';
import {
  useFollowUpsFutureQuery,
  useFollowUpsQuery,
  useSalesQualifiedFutureQuery,
  useSalesQualifiedQuery
} from '../../../../../../shared';
import { ButtonBase, Stack, Typography } from '@mui/material';
import { CircularProgressWithLabel } from '../circular-progress-with-label';
import { useOutdatedFollowUps } from '../../../../hooks/use-outdated-follow-ups';
import { useOutdatedSql } from '../../../../hooks/use-outdated-sql';
import { Link } from 'react-router-dom';
import { getRoute } from '../../../../../../app/router';
import { NavButton } from '../nav-button';

type Props = {
  agentId?: string
};
export const SqlCard = ({agentId}: Props) => {
  const outdated = useOutdatedSql(agentId)
  const {data: salesQualifiedData} = useSalesQualifiedQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId,
      pageInput: {page: 0, size: 1},
    },
    skip: !agentId,
  });
  const salesQualifiedCount = salesQualifiedData?.salesQualified.totalElements;

  const {data: futureData} = useSalesQualifiedFutureQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId,
      pageInput: {page: 0, size: 1},
    },
    skip: !agentId,
  });
  const futureCount = futureData?.salesQualifiedFuture.totalElements;


  const percent = +salesQualifiedCount ? Math.round((outdated?.length || 0) / salesQualifiedCount * 100) : 0;

  const title = percent === 0 ? 'up to date' : percent < 15 ? `${100 - percent}% are up to date` : `${percent}% outdated `;
  const color = percent === 0 ? 'success' : percent < 15 ? 'info' : 'error';

  return (
    <DashboardCard>
      <Typography variant={'h3'} mb={1}>Sales Qualified</Typography>

      <Typography variant={'body2'} mb={1} color={`${color}.600`} align={'center'}>Next Contact Dates: <b>{title}</b></Typography>
      <CircularProgressWithLabel color={color} size={100} value={100 - percent} thickness={2}>
        <ButtonBase sx={{mt: 1, flexDirection: 'column', alignItems: 'center', p: 1, borderRadius: 2}} component={Link} to={`/${getRoute('dashboard')}/today-sql/${agentId}`}>
          <Typography lineHeight={'1!important'} variant={'h1'}>{salesQualifiedCount - (outdated?.length || 0)}</Typography>
          <Typography variant={'caption'} align={'center'}>Today</Typography>
        </ButtonBase>
      </CircularProgressWithLabel>

      <Stack direction={'row'} gap={2} mt={2}>
        <NavButton to={`/${getRoute('dashboard')}/outdated-sql/${agentId}`} color={outdated?.length ? '#DE3124' : 'success.500'}>
          <Typography variant={'subtitle1'} align={'center'} color={`${outdated?.length ? 'error' : 'success'}.500`}>{outdated?.length || 0}</Typography>
          <Typography variant={'caption'} align={'center'} color={`${outdated?.length ? 'error' : 'success'}.500`}>Outdated</Typography>
        </NavButton>
        <NavButton to={`/${getRoute('dashboard')}/future-sql/${agentId}`} color={'#0288d1'}>
          <Typography variant={'subtitle1'} align={'center'} color={'#0288d1'}>{futureCount}</Typography>
          <Typography variant={'caption'} align={'center'} color={'#0288d1'}>Future</Typography>
        </NavButton>
      </Stack>
    </DashboardCard>
  );
};
